import ja from './locales/ja.json';
import {IntlShape, useIntl} from 'react-intl';

export const messages = {
  ja,
};

export function useMessage(
  labelId: string,
  defaultLabel?: string,
): string | undefined {
  const intl = useIntl();
  return getMessage(intl, labelId, defaultLabel);
}

export function getMessage(
  intl: IntlShape,
  labelId: string,
  defaultLabel?: string,
): string | undefined {
  const msg = intl.formatMessage({
    id: labelId,
  });

  // An error occurs if the string is empty because the message is treated as nonexistent,
  // so a single space ' ' is set when you want it to be empty.
  if (msg === ' ') {
    return undefined;
  }

  if (msg === labelId) {
    return defaultLabel;
  }

  return msg;
}
